import {call, put, takeLatest} from 'redux-saga/effects'
import {LOGIN_REQUESTED, LOGIN_SUCCEEDED} from './actionTypes'
import {loadSessions, loginSucceeded} from './actions'
import {getInitialData, getLogin} from '../api'
import {replace} from 'connected-react-router'

// worker Saga: will be fired on LOGIN actions
function* login(action) {
    const {formData, from} = action.payload;
    try {
        const user = yield call(getLogin, formData);

        /* Cache user to session storage */
        yield sessionStorage.setItem('user', JSON.stringify(user));

        yield put(loginSucceeded(user, from));

    } catch (e) {
        alert(e);
        //yield put({type: "USER_FETCH_FAILED", message: e.message});
    }
}

function* loginSuccess(action) {
    const {user, from} = action.payload;

    try {
        const results = yield getInitialData(user.api_token);
        yield put(loadSessions(results[0], results[1].data, results[2].data));
        if (from) yield put(replace(from))  // Perform redirect to from page
    } catch (e) {
        alert(e);
        //yield put({type: "USER_FETCH_FAILED", message: e.message});
    }
}

/*
  Alternatively you may use takeLatest.

  Does not allow concurrent fetches of user. If "USER_FETCH_REQUESTED" gets
  dispatched while a fetch is already pending, that pending fetch is cancelled
  and only the latest one will be run.
*/
function* rootSaga() {
    yield takeLatest(LOGIN_REQUESTED, login);
    yield takeLatest(LOGIN_SUCCEEDED, loginSuccess);
}


export default rootSaga;
